(function () {
function $09cbfe85151ea6c6$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $a0bc1859061deae1$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $89eb4a55c543f071$export$e62c166da838fa3(arr) {
    return (0, $09cbfe85151ea6c6$export$e6256bf45c68d561)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $a0bc1859061deae1$export$60dbc22abd7da546)();
}



function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}



function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$var$field = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialField = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $3d28d7f1aac198f5$var$field;
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        this.gameStatus = "idle";
        this.score = 0;
        this.field = initialField;
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                for(var j = 0; j < this.field.length; j++)for(var i = 1; i < this.field[j].length; i++){
                    var k = i;
                    while(k > 0 && this.field[j][k - 1] === 0){
                        this.field[j][k - 1] = this.field[j][k];
                        this.field[j][k] = 0;
                        k--;
                    }
                    if (k > 0 && this.field[j][k - 1] === this.field[j][k]) {
                        this.score += this.field[j][k - 1] * 2;
                        this.field[j][k - 1] *= 2;
                        this.field[j][k] = 0;
                    }
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                for(var j = 0; j < this.field.length; j++)for(var i = this.field[j].length - 1; i >= 0; i--){
                    var k = i;
                    while(k < this.field[j].length - 1 && this.field[j][k + 1] === 0){
                        this.field[j][k + 1] = this.field[j][k];
                        this.field[j][k] = 0;
                        k++;
                    }
                    if (k < this.field[j].length - 1 && this.field[j][k + 1] === this.field[j][k]) {
                        this.score += this.field[j][k + 1] * 2;
                        this.field[j][k + 1] *= 2;
                        this.field[j][k] = 0;
                    }
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var size = $3d28d7f1aac198f5$var$field.length;
                for(var j = 0; j < size; j++){
                    var mergeOccurred = false;
                    for(var i = 1; i < size; i++)if ($3d28d7f1aac198f5$var$field[i][j] !== 0) {
                        var k = i;
                        while(k > 0 && $3d28d7f1aac198f5$var$field[k - 1][j] === 0){
                            $3d28d7f1aac198f5$var$field[k - 1][j] = $3d28d7f1aac198f5$var$field[k][j];
                            $3d28d7f1aac198f5$var$field[k][j] = 0;
                            k--;
                        }
                        if (!mergeOccurred && k > 0 && $3d28d7f1aac198f5$var$field[k - 1][j] === $3d28d7f1aac198f5$var$field[k][j]) {
                            $3d28d7f1aac198f5$var$field[k - 1][j] *= 2;
                            $3d28d7f1aac198f5$var$field[k][j] = 0;
                            mergeOccurred = true;
                        }
                    }
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                for(var i = this.field.length - 2; i >= 0; i--)for(var j = 0; j < this.field[i].length; j++){
                    var k = i;
                    while(k < this.field.length - 1 && this.field[k + 1][j] === 0){
                        this.field[k + 1][j] = this.field[k][j];
                        this.field[k][j] = 0;
                        k++;
                    }
                    if (k < this.field.length - 1 && this.field[k + 1][j] === this.field[k][j]) {
                        this.score += this.field[k + 1][j] * 2;
                        this.field[k + 1][j] *= 2;
                        this.field[k][j] = 0;
                    }
                }
            }
        },
        {
            key: "start",
            value: function start() {
                this.addingNumberToField();
                this.addingNumberToField();
                this.gameStatus = "playing";
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.field = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.addingNumberToField();
                this.addingNumberToField();
                (0, $197cd56b15c33885$export$65972ef3a64ea716)();
                this.gameStatus = "playing";
                this.score = 0;
                (0, $197cd56b15c33885$export$c446bd3f79853be8)();
            }
        },
        {
            key: "addingNumberToField",
            value: function addingNumberToField() {
                var randomRow = +Math.floor(Math.random() * 4);
                var randomCeil = +Math.floor(Math.random() * 4);
                var firstNum = Math.random() >= 0.9 ? 4 : 2;
                if (!this.field[randomRow][randomCeil]) {
                    this.field[randomRow][randomCeil] = firstNum;
                    (0, $197cd56b15c33885$export$65972ef3a64ea716)();
                } else this.addingNumberToField();
            }
        },
        {
            key: "checkVictory",
            value: function checkVictory() {
                for(var i = 0; i < this.field.length; i++){
                    for(var j = 0; j < this.field[i].length; j++)if (this.field[i][j] === 2048) {
                        this.gameStatus = "win";
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "canMoveCellsRight",
            value: function canMoveCellsRight() {
                for(var j = 0; j < this.field.length; j++)for(var i = this.field[j].length - 1; i >= 0; i--){
                    if (this.field[j][i + 1] === 0 && this.field[j][i] !== this.field[j][i + 1] || this.field[j][i + 1] === this.field[j][i] && this.field[j][i] !== 0) return true;
                }
                return false;
            }
        },
        {
            key: "canMoveCellsLeft",
            value: function canMoveCellsLeft() {
                for(var j = 0; j < this.field.length; j++)for(var i = this.field[j].length - 1; i >= 1; i--){
                    if (this.field[j][i - 1] === 0 && this.field[j][i] !== this.field[j][i - 1] || this.field[j][i - 1] === this.field[j][i] && this.field[j][i] !== 0) return true;
                }
                return false;
            }
        },
        {
            key: "canMoveCellsUp",
            value: function canMoveCellsUp() {
                for(var i = 1; i < this.field.length; i++)for(var j = 0; j < this.field[i].length; j++){
                    if (this.field[i - 1][j] === 0 && this.field[i][j] !== this.field[i - 1][j] || this.field[i - 1][j] === this.field[i][j] && this.field[i][j] !== 0) return true;
                }
                return false;
            }
        },
        {
            key: "canMoveCellsDown",
            value: function canMoveCellsDown() {
                for(var i = 0; i < this.field.length - 1; i++)for(var j = 0; j < this.field[i].length; j++){
                    if (this.field[i + 1][j] === 0 && this.field[i][j] !== this.field[i + 1][j] || this.field[i + 1][j] === this.field[i][j] && this.field[i][j] !== 0) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
var $197cd56b15c33885$var$messageStartGame = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWinGame = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLoseGame = document.querySelector(".message-lose");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$_document_getElementsByClassName = (0, $89eb4a55c543f071$export$e62c166da838fa3)(document.getElementsByClassName("field-cell")), $197cd56b15c33885$var$cells = $197cd56b15c33885$var$_document_getElementsByClassName.slice(0);
function $197cd56b15c33885$export$c446bd3f79853be8() {
    for(var i = 0; i < $197cd56b15c33885$var$cells.length; i++){
        $197cd56b15c33885$var$cells[i].className = "field-cell";
        if ($197cd56b15c33885$var$game.field.flat()[i]) $197cd56b15c33885$var$cells[i].classList.add("field-cell--".concat($197cd56b15c33885$var$game.field.flat()[i]));
    }
}
function $197cd56b15c33885$export$65972ef3a64ea716() {
    for(var i = 0; i < $197cd56b15c33885$var$cells.length; i++)(0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)($197cd56b15c33885$var$cells)[i].innerText = $197cd56b15c33885$var$game.field.flat()[i] || "";
    $197cd56b15c33885$var$gameScore.innerText = $197cd56b15c33885$var$game.score;
}
function $197cd56b15c33885$var$handleUpButtonClickAndUpdateField() {
    if (!$197cd56b15c33885$var$game.checkVictory() && $197cd56b15c33885$var$game.gameStatus === "playing") {
        $197cd56b15c33885$var$game.moveUp();
        $197cd56b15c33885$var$game.addingNumberToField();
        $197cd56b15c33885$export$65972ef3a64ea716();
        $197cd56b15c33885$export$c446bd3f79853be8();
    }
    if ($197cd56b15c33885$var$game.checkVictory()) $197cd56b15c33885$var$messageWinGame.classList.remove("hidden");
}
function $197cd56b15c33885$var$handleDownButtonClickAndUpdateField() {
    if (!$197cd56b15c33885$var$game.checkVictory() && $197cd56b15c33885$var$game.gameStatus === "playing") {
        $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$game.addingNumberToField();
        $197cd56b15c33885$export$65972ef3a64ea716();
        $197cd56b15c33885$export$c446bd3f79853be8();
    }
    if ($197cd56b15c33885$var$game.checkVictory()) $197cd56b15c33885$var$messageWinGame.classList.remove("hidden");
}
function $197cd56b15c33885$var$handleRightButtonClickAndUpdateField() {
    if (!$197cd56b15c33885$var$game.checkVictory() && $197cd56b15c33885$var$game.gameStatus === "playing") {
        $197cd56b15c33885$var$game.moveRight();
        $197cd56b15c33885$var$game.addingNumberToField();
        $197cd56b15c33885$export$65972ef3a64ea716();
        $197cd56b15c33885$export$c446bd3f79853be8();
    }
    if ($197cd56b15c33885$var$game.checkVictory()) $197cd56b15c33885$var$messageWinGame.classList.remove("hidden");
}
function $197cd56b15c33885$var$handleLeftButtonClickAndUpdateField() {
    if (!$197cd56b15c33885$var$game.checkVictory() && $197cd56b15c33885$var$game.gameStatus === "playing") {
        $197cd56b15c33885$var$game.moveLeft();
        $197cd56b15c33885$var$game.addingNumberToField();
        $197cd56b15c33885$export$65972ef3a64ea716();
        $197cd56b15c33885$export$c446bd3f79853be8();
    }
    if ($197cd56b15c33885$var$game.checkVictory()) $197cd56b15c33885$var$messageWinGame.classList.remove("hidden");
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if (!$197cd56b15c33885$var$startButton.classList.contains("start")) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$messageLoseGame.classList.add("hidden");
        $197cd56b15c33885$var$messageWinGame.classList.add("hidden");
        $197cd56b15c33885$var$gameScore.innerText = $197cd56b15c33885$var$game.score;
    }
    if ($197cd56b15c33885$var$startButton.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.innerText = "Restart";
        $197cd56b15c33885$var$messageStartGame.classList.add("hidden");
    }
    $197cd56b15c33885$export$65972ef3a64ea716();
    $197cd56b15c33885$export$c446bd3f79853be8();
});
document.addEventListener("keyup", function(action) {
    var isEveryMoveBlocked = !$197cd56b15c33885$var$game.canMoveCellsDown() && !$197cd56b15c33885$var$game.canMoveCellsUp() && !$197cd56b15c33885$var$game.canMoveCellsRight() && !$197cd56b15c33885$var$game.canMoveCellsLeft();
    switch(action.key){
        case "ArrowUp":
            if ($197cd56b15c33885$var$game.canMoveCellsUp()) $197cd56b15c33885$var$handleUpButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $197cd56b15c33885$var$game.gameStatus = "lose";
                $197cd56b15c33885$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowLeft":
            if ($197cd56b15c33885$var$game.canMoveCellsLeft()) $197cd56b15c33885$var$handleLeftButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $197cd56b15c33885$var$game.gameStatus = "lose";
                $197cd56b15c33885$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowDown":
            if ($197cd56b15c33885$var$game.canMoveCellsDown()) $197cd56b15c33885$var$handleDownButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $197cd56b15c33885$var$game.gameStatus = "lose";
                $197cd56b15c33885$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        case "ArrowRight":
            if ($197cd56b15c33885$var$game.canMoveCellsRight()) $197cd56b15c33885$var$handleRightButtonClickAndUpdateField();
            if (isEveryMoveBlocked) {
                $197cd56b15c33885$var$game.gameStatus = "lose";
                $197cd56b15c33885$var$messageLoseGame.classList.remove("hidden");
            }
            break;
        default:
            break;
    }
});

})();
//# sourceMappingURL=index.2651d60b.js.map
